import { Box, MenuItem, Select, Typography } from "@material-ui/core";

import useCoupons from "../../../hooks/useCoupons";
import { useField } from "react-final-form";
import { useState } from "react";

const TierBenefitInput = ({ label }) => {
  const { coupons, loading, error } = useCoupons();

  const {
    input: { onChange, value },
  } = useField("privileges[0].item.coupon_id");
  const [selection, setSelection] = useState(value);
  if (loading) return null;
  if (error) return null;
  const handleOnChange = (e) => {
    //
    setSelection(e.target.value);
    onChange(e.target.value);
  };
  let filteredCoupon = coupons.filter(
    (c) =>
      c.type === "Discount" ||
      c.type === "Discount Percent" ||
      c.type === "Multiplier" ||
      c.type === "Reward"
  );
  return (
    <Box>
      {label ? <Typography>{label}</Typography> : null}
      <Select
        value={selection}
        onChange={handleOnChange}
        style={{ width: 150 }}
      >
        {filteredCoupon.map((coupon) => {
          return <MenuItem value={coupon.id}>{coupon.name}</MenuItem>;
        })}
      </Select>
    </Box>
  );
};

export default TierBenefitInput;
